import { Link, Navigate, useLocation, useParams } from 'react-router-dom';
import { useAuth } from '@/context/AuthContext';
import SiteHeader from '@/components/feature/SiteHeader';
import SiteFooter from '@/components/feature/SiteFooter';
import Button from '@/components/base/Button';
import LessonContent from '@/pages/lesson/components/LessonContent';
import { getLesson } from '@/data/lessons';

export default function LessonPage() {
  const { user, loading } = useAuth();
  const location = useLocation();
  const { id } = useParams<{ id: string }>();
  const lessonId = Number(id);
  const lesson = Number.isFinite(lessonId) ? getLesson(lessonId) : undefined;

  if (loading) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-[#fffaf4]">
        <div className="flex items-center gap-3 text-sm font-semibold text-slate-600">
          <i className="ri-loader-4-line animate-spin text-xl text-orange-500" />
          Carregando sua conta...
        </div>
      </div>
    );
  }

  if (!user) {
    const next = location.pathname + location.search;
    return <Navigate to={`/criar-conta?next=${encodeURIComponent(next)}`} replace />;
  }

  if (!lesson) {
    return (
      <div className="flex min-h-screen flex-col bg-background-50">
        <SiteHeader />
        <main className="flex flex-1 items-center justify-center px-4 py-20">
          <div className="max-w-md text-center">
            <span className="mx-auto w-16 h-16 flex items-center justify-center rounded-full bg-secondary-100 text-secondary-700">
              <i className="ri-error-warning-line text-3xl" />
            </span>
            <h1 className="mt-5 font-heading text-2xl font-bold text-foreground-950">
              Aula não encontrada
            </h1>
            <p className="mt-2 text-foreground-700">
              O curso tem 48 aulas. Escolha uma delas na lista para começar.
            </p>
            <div className="mt-6 flex justify-center">
              <Link to="/aulas" className="contents">
                <Button variant="primary" icon="ri-list-check">
                  Ver todas as aulas
                </Button>
              </Link>
            </div>
          </div>
        </main>
        <SiteFooter />
      </div>
    );
  }

  return (
    <div className="flex min-h-screen flex-col bg-background-50">
      <SiteHeader />
      <main className="flex-1">
        <LessonContent key={lesson.id} lesson={lesson} />
      </main>
      <SiteFooter />
    </div>
  );
}